import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { StateOrderIdentification } from '../../enums/StateOrderIdentification';
import { SeparationType } from '../../enums/SeparationType';
import { StatePrescriptionIdentification } from '../../enums/StatePrescriptionIdentification';
import { OrderForListing } from '../../models/OrderForListing';
import { StateLog } from '../../models/StateLog';
import { StatePrescriptionLog } from '../../models/StatePrescriptionLog';

interface IStateOrderPopoverProps {
  orderForListing?: OrderForListing;
  currentState?: StateLog;
  currentStatePrescription?: StatePrescriptionLog;
  color?: string;
  tooltipText?: string;
  alertType: 'no_nfe'|'no_recipe'
}

export const StateOrderPopover: React.FC<IStateOrderPopoverProps> = ({
  orderForListing,
  currentState,
  currentStatePrescription,
  color,
  alertType
}) => {

  if (!orderForListing) return null;

  if (alertType === 'no_nfe') {
    const currentStateNeedsNFe = currentState?.currentStateId === StateOrderIdentification.NFImpressa ||
      currentState?.currentStateId === StateOrderIdentification.AguardandoPacking ||
      currentState?.currentStateId === StateOrderIdentification.ProntoParaEnvio ||
      currentState?.currentStateId === StateOrderIdentification.Enviado;

    const orderHasNFe = orderForListing.order.isPhysicalStore || 
                       (orderForListing.order.activeNfeCount != undefined &&
                        orderForListing.order.activeNfeCount != null &&
                        orderForListing.order.activeNfeCount > 0);

    return currentStateNeedsNFe && !orderHasNFe ?
      <span style={{ marginLeft: '5px' }}>
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip>Pedido sem Nota Fiscal</Tooltip>}
        >
          <span><FontAwesomeIcon icon={faExclamationCircle} color={color || 'red'} size='sm' /></span>
        </OverlayTrigger>
      </span>
    : null;
  }

  if (alertType === 'no_recipe' && orderForListing.order.separationType === SeparationType.Prescription) {
    return currentStatePrescription?.currentStateId === StatePrescriptionIdentification.SemReceita ?
      <span style={{ marginLeft: '5px' }}>
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip>Pedido ainda sem Receita</Tooltip>}
        >
          <span><FontAwesomeIcon icon={faExclamationCircle} color={color || 'red'} size='sm' /></span>
        </OverlayTrigger>
      </span>
    : null;
  }

  return null;
}